import React from "react";
import { Phone } from "lucide-react";
import { aboutData, navData } from "../../data/mockData";

const AboutSection = ({ scrollToQuote }) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              alt="NeatWave technician with floor cleaning machine beside the branded NeatWave van in Cardiff"
              className="rounded-2xl shadow-2xl w-full"
              src={aboutData.vanImage}
            />
          </div>
          <div className="space-y-6">
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900">
              {aboutData.title}
            </h3>
            <div className="space-y-4 text-lg text-slate-600">
              {aboutData.paragraphs.map((p) => (
                <p key={p.id}>{p.text}</p>
              ))}
              <p className="font-semibold text-sky-600">{aboutData.highlight}</p>
            </div>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={scrollToQuote}
                className="bg-sky-600 hover:bg-sky-700 text-white font-medium px-8 py-2.5 rounded-md shadow transition-colors text-sm"
              >
                Get Free Quote
              </button>
              <a
                href={`tel:${navData.phoneLink}`}
                className="inline-flex items-center border-2 border-sky-600 text-sky-600 hover:bg-sky-50 font-medium px-8 py-2.5 rounded-md transition-colors text-sm"
              >
                <Phone className="w-5 h-5 mr-2" />
                {navData.phone}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
